import { transformAddress } from './address';
import { transformCurrencyAmountDto } from './currency-amount';
export const transformRequestReturnDetailsPickupPointDetailsDiscountDto = _ref => {
  let {
    percent,
    note
  } = _ref;
  return {
    percent,
    note
  };
};
export const transformRequestReturnDetailsPickupPointDto = _ref2 => {
  let {
    pickup_point_code,
    carrier_logo_url,
    carrier_name,
    price,
    pickup_point_name,
    pickup_point_address,
    value_proposition,
    discount,
    price_before_discount,
    lowest_price_in_30_days
  } = _ref2;
  return {
    pickupPointCode: pickup_point_code,
    carrierLogoUrl: carrier_logo_url,
    carrierName: carrier_name,
    price: transformCurrencyAmountDto(price),
    pickupPointName: pickup_point_name,
    pickupPointAddress: pickup_point_address,
    valueProposition: value_proposition,
    discount: discount && transformRequestReturnDetailsPickupPointDetailsDiscountDto(discount),
    priceBeforeDiscount: price_before_discount && transformCurrencyAmountDto(price_before_discount),
    lowestPriceIn30Days: lowest_price_in_30_days && transformCurrencyAmountDto(lowest_price_in_30_days)
  };
};
export const transformRequestReturnDetailsPaymentOptionDto = _ref3 => {
  let {
    code,
    title,
    subtitle
  } = _ref3;
  return {
    code,
    title,
    subtitle
  };
};
export const transformRequestReturnDetailsPaymentOptionsDto = options => options.map(transformRequestReturnDetailsPaymentOptionDto);
export const transformRequestReturnDetailsDto = _ref4 => {
  let {
    photo_url,
    user_address,
    phone_number,
    phone_number_requirement,
    explanation_note,
    payer_selection,
    pickup_point_details,
    package_type_id
  } = _ref4;
  return {
    photoUrl: photo_url,
    userAddress: user_address && transformAddress(user_address),
    phoneNumber: phone_number,
    phoneNumberRequirement: phone_number_requirement,
    explanationNote: explanation_note,
    payerSelection: payer_selection && transformRequestReturnDetailsPaymentOptionsDto(payer_selection),
    pickupPointDetails: pickup_point_details && transformRequestReturnDetailsPickupPointDto(pickup_point_details),
    packageTypeId: package_type_id
  };
};